// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1b9pf","largestCol":"styles_largestCol__2JfoS","smallestCol":"styles_smallestCol__3WtpU"};